import useMediaQuery from '@mui/material/useMediaQuery';

const MAX_MOBILE_WIDTH_IN_PX = 768;
const mobileQuery = `(max-width: ${MAX_MOBILE_WIDTH_IN_PX}px)`;

export const useMobile = () => {
  const isMobile = useMediaQuery(mobileQuery);
  return isMobile;
};
